import script from "./UserMessageCreated.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserMessageCreated.vue?vue&type=script&lang=js"
export * from "./UserMessageCreated.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserMessageCreated.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/user-message/UserMessageCreated.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "83dca96e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('83dca96e', __exports__)) {
    api.reload('83dca96e', __exports__)
  }
  
}


export default __exports__